const firebaseConfig = {
    apiKey: "AIzaSyB2pe2FgVThkTCCz8S9tA4UsPzNz_zac9g",
    authDomain: "pathfinder-41e52.firebaseapp.com",
    databaseURL: "https://pathfinder-41e52.firebaseio.com",
    projectId: "pathfinder-41e52",
    storageBucket: "pathfinder-41e52.appspot.com",
    messagingSenderId: "1080385293295",
    appId: "1:1080385293295:web:63ccf213454acccd11441a",
    measurementId: "G-BBQLXPE1VN"
  }

  export default firebaseConfig